var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "the-section",
    {
      staticClass: "offer",
      style: { color: _vm.job.colors["text-secondary"] },
      attrs: { id: _vm.id, legend: _vm.job.title },
    },
    [
      _c(
        "h2",
        { staticClass: "title", style: { color: _vm.job.colors.title } },
        [_vm._v("\n        " + _vm._s(_vm.job.subtitle) + "\n    ")]
      ),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass: "text",
          style: { color: _vm.job.colors["text-primary"] },
        },
        [_vm._v("\n        " + _vm._s(_vm.job.description) + "\n    ")]
      ),
      _vm._v(" "),
      _c("caption-tags", {
        attrs: { tags: _vm.job.tags, color: _vm.job.colors["text-secondary"] },
      }),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "link text",
          attrs: { href: _vm.job.link, target: "_blank" },
        },
        [
          _c("line-footer"),
          _vm._v(" "),
          _c("span", [_vm._v("Become a "), _c("strong", [_vm._v("member")])]),
          _vm._v(" "),
          _c("line-footer"),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }